/* eslint-disable jsx-a11y/label-has-associated-control,jsx-a11y/control-has-associated-label */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Switch from 'react-switch';
import {
  connectSSO,
  connectLogout,
  initCCP,
  resetIfTimeout,
} from '../../../actions/telephony';
import { getAgent } from '../../../actions/user';
import { fmtAgent } from '../../../common/utils/format';

function ReadyForCallButton() {
  const dispatch = useDispatch();
  const [ loading, setLoading ] = useState(false);
  const {
    telephony: { agentState, loginAttempt },
    agent: {
      phoneInfo: agentProvisioned,
      username: agentUsername,
      phoneInfo = {},
    },
    theme: {
      connectLoginTimeout = 30,
    },
  } = useSelector(store => store);
  let { instanceDomain } = (phoneInfo || {});

  const handleLogin = async () => {
    console.log('[LOGGING INTO CONNECT]');

    // check in <connectLoginTimeout> seconds if we're logged in,
    //   if not, stop the attempt and reset to offline state
    setTimeout(resetIfTimeout, connectLoginTimeout * 1000);

    try {
      const samlData = await connectSSO(agentUsername);

      // if the agent is not previously provisioned, we need to get fetch the new
      // phone_info object from the api which is provisioned and use the instance
      // domain to initCCP. If we don't, initCCP will be passed undefined and will
      // fail to init.
      if (!agentProvisioned) {
        console.log('[CONNECT USER NOT PROVISIONED, NEED TO RELOAD AGENT]');
        const a = await getAgent();
        const formattedAgent = fmtAgent(a);
        ({ phoneInfo: { instanceDomain } } = formattedAgent);
        dispatch({ type: 'SET_AGENT', agent: formattedAgent });
        ({ phoneInfo: { instanceDomain } } = formattedAgent);
      }

      /* eslint-disable */
      dispatch({ type: 'SET_CONNECT_LOGIN_STATUS', payload: true });
      // dispatch({ type: 'SET_IFRAME', data: samlData });
      const base = window.location.origin;
      const destinationURL = encodeURIComponent(samlData.destination_url);
      const relayState = encodeURIComponent(samlData.RelayState);
      const samlResponse = encodeURIComponent(samlData.SAMLResponse);
      const samlURL = `${base}/saml?destinationURL=${destinationURL}&RelayState=${relayState}&SAMLResponse=${samlResponse}`;

      await initCCP(samlData, instanceDomain);

      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log('ReadyForCall.handleLogin: ', err);
    }
  };

  function handleLogout() {
    console.log('[LOGGING OUT OF CONNECT]');

    connectLogout(instanceDomain)
      .then(() => {
        dispatch({ type: 'SET_CONNECT_LOGIN_STATUS', payload: false });
        dispatch({ type: 'CLEAR_IFRAME' });
        dispatch({ type: 'CLEAR_TELEPHONY' });
        setLoading(false);
      }).catch((err) => {
        setLoading(false);
        console.log('ReadyForCall.handleLogout: ', err);
      });
  }

  function handleChange() {
    setLoading(true);
    // dispatch({ type: 'UPDATE_AGENT_STATE', newState: 'Authenticating' });

    if (loginAttempt) {
      handleLogout();
    } else {
      handleLogin();
    }
  }

  useEffect(() => {
    if (loginAttempt && agentState === 'Offline') {
      console.log('-------------------- WHOA NELLY ----------------------');
      setLoading(false);
      handleLogin();
    }
  }, []);

  return (
    <label
      style={{ marginBottom: '0px' }}
      className="d-flex align-items-center"
    >
      <Switch
        onChange={(e) => handleChange(e)}
        checked={(loginAttempt && agentState !== 'Authenticating' && agentState !== 'Offline')}
        disabled={(loading || agentState === 'Authenticating')}
      />
      <span
        className={[
          'ms-3',
          (loginAttempt && agentState !== 'Authenticated' && agentState !== 'Offline') ? '' : 'text-muted',
        ].join(' ')}
      >
        Ready to receive call from client
      </span>
    </label>
  );
}

export default ReadyForCallButton;
